
export const ConsoleOutput = (componentName: string, info: string) => {
    
    const cssVersion = 'background-color: #AD36FF; color: white; padding: 1px 3px; border-radius: 4px; font-weight: bold;margin-right: 5px;';
    const cssInfo = 'background-color: #388EE8; color: black; padding: 1px 3px; border-radius: 4px; font-weight: bold;';
    
    console.info(`%c ${componentName} %cINFO: ${info}`, cssVersion, cssInfo); 
};